import React from 'react'

// material ui
import Container from '@mui/material/Container'

// components
import EditPersonHeader from 'components/shared/EditPersonHeader'
import Loading from 'components/atoms/Loading'
import Breadcrumbs from 'components/shared/Breadcrumbs'

// containers
import Form from 'components/account/Parents/Form'

const EditParent = props => {
  const { parent, account, season, queryLoading, mutationLoading, form } = props

  return (
    <Container maxWidth='md'>
      <Breadcrumbs
        crumbs={[
          ['Account Overview', '/'],
          ['Parents/Guardians'],
          [parent ? parent.firstName : '…']
        ]}
      />
      <EditPersonHeader
        personType='Parent / Guardian'
        person={parent}
        season={season}
        account={account}
      />
      {queryLoading || (!form?.id && !!parent) ? (
        <Loading />
      ) : (
        <Form
          buttonText={mutationLoading ? 'Saving…' : 'Save'}
          editMode
          showFormFields={!!parent}
          {...props}
        />
      )}
    </Container>
  )
}

export default EditParent
